/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarketFormWarningsData
 */
export interface MarketFormWarningsData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof MarketFormWarningsData
     */
    label?: ValidationMessage;
}

export function MarketFormWarningsDataFromJSON(json: any): MarketFormWarningsData {
    return MarketFormWarningsDataFromJSONTyped(json, false);
}

export function MarketFormWarningsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketFormWarningsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
    };
}

export function MarketFormWarningsDataToJSON(value?: MarketFormWarningsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': ValidationMessageToJSON(value.label),
    };
}


